import { Injectable, afterRender } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { BehaviorSubject, distinctUntilChanged } from 'rxjs';
import { NavigationService } from './navigation.service';

@Injectable({
  providedIn: 'root'
})
export class PageTitleService {
  private readonly COMPANY = 'Trucker Ally'

  private _inspectr$ = new BehaviorSubject<boolean>(false);
  public readonly inspectr$ = this._inspectr$.asObservable().pipe(distinctUntilChanged());

  public readonly title$ = new BehaviorSubject<string>(this.COMPANY);

  constructor(private router: Router, private title: Title, private nav: NavigationService) {
    this.nav.navigation$.subscribe(() => {
      this.setTitle();
    });

    afterRender(() => {
      this.isInspectR();
    })
  }

  isInspectR() {
    const inspectr = localStorage.getItem('inspectr');

    this._inspectr$.next(this.inspectRToBoolean(inspectr));

    return this._inspectr$.value;
  }

  setInspectR(inspectR: string): void
  setInspectR(inspectR: boolean): void
  setInspectR(inspectR: any = false): void {
    if (typeof inspectR === 'string') {
      inspectR = this.inspectRToBoolean(inspectR);
    }

    localStorage.setItem('inspectr', inspectR ? 'true' : 'false');

    this._inspectr$.next(inspectR);
  }

  private inspectRToBoolean(inspectR?: string | null) {
    if (!inspectR) return false

    return /true/ig.test(inspectR)
  }

  get PageTitle() {
    return this.title$.value;
  }

  setTitle(message?: string, inverse = false) {
    let title = `${message} - ${this.COMPANY}`;

    if (inverse) {
      title = `${this.COMPANY} - ${message}`;
    }

    if (message) {
      this.title$.next(title);
    }

    this.title.setTitle(this.PageTitle);
  }
}